// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"00edc693","455":"f2583f8c","977":"105e5fcc"}[chunkId] + ".chunk.js";
};